import React, {useEffect, useState} from "react";
import zoomImg from "../../../../assets/icons/imgBtn.svg";
import BlogImagePopper from "./BlogImageLarge";
import image1 from "../../../../assets/images/blog20/blog20-1.png";
import image6 from "../../../../assets/images/blog20/blog20-6.png";
import image8 from "../../../../assets/images/blog20/blog20-8.png";
import image2 from "../../../../assets/images/blog20/blog20-2.png";
import image5 from "../../../../assets/images/blog20/blog20-5.png";
import image30 from "../../../../assets/images/blog20/blog20-30.png";
import image4 from "../../../../assets/images/blog20/blog20-4.png";
import image3 from "../../../../assets/images/blog20/blog20-3.png";
import image23 from "../../../../assets/images/blog20/blog20-23.png";
import image21 from "../../../../assets/images/blog20/blog20-21.png";
import image20 from "../../../../assets/images/blog20/blog20-20.png";
import image31 from "../../../../assets/images/blog20/blog20-31.png";
import image7 from "../../../../assets/images/blog20/blog20-7.png";
import image13 from "../../../../assets/images/blog20/blog20-13.png";
import image11 from "../../../../assets/images/blog20/blog20-11.png";
import image17 from "../../../../assets/images/blog20/blog20-17.png";
import image19 from "../../../../assets/images/blog20/blog20-19.png";
import image15 from "../../../../assets/images/blog20/blog20-15.png";
import image18 from "../../../../assets/images/blog20/blog20-18.png";
import image36 from "../../../../assets/images/blog20/blog20-36.png";
import image33 from "../../../../assets/images/blog20/blog20-33.png";
import image28 from "../../../../assets/images/blog20/blog20-28.png";
import image10 from "../../../../assets/images/blog20/blog20-10.png";

const Blog20 = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handleRedirect = (url) => {
    window.open(url, "_blank");
  };
  const handleLargeImg = (img) => {
    setSelectedImage(img);
  };
  return (
    <div className="MainNewBlog">
      <div className="blogHeader">
        <h2 className="headerBoldText mainHeader">Weekly Market Outlook – May 26, 2025</h2>
      </div>
      <div className="blogContentnew">
        <p
          style={{
            textAlign: "justify",
            fontFamily: "var(--header-font-family)",
            fontSize: "24px",
            fontStyle: "normal",
            fontWeight: 600,
            lineHeight: "30px",
            color: "#010310",
          }}
        >
          Tariff Tensions, Bond Blowouts, and Breadth Breakdown: The Calm Is a Trap
        </p>
        <p>
          Markets limped into Memorial Day weekend with Trump firing trade threats, bonds buckling under supply pressure, and equity breadth flashing red. The short-term calm masks unresolved risks:
          global bond tantrums, capital flight from the dollar, and a rally losing internal momentum. This week brings NVIDIA earnings and crucial inflation reads, with traders on edge.
        </p>
        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Market Overview: “The Orange One Returns. So Does Vol.”</p>
              <p>
                Memorial Day began with Trump threatening Apple with 25% tariffs unless it manufactures in the U.S., alongside a 50% tariff on EU imports from June 1st. By Sunday night, he backed off,
                delaying the EU action to July 9th, triggering a 1% futures pop. But Asia still closed lower, and U.S. markets remain stuck in a loop of
                <span className="highlightedText"> headline roulette.</span>
              </p>
              <div className="relatedImg">
                <img
                  src={image1}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image1)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
              <p>
                Trump’s volatile antics are losing their bite, but not without damage. Institutions are maintaining underweight risk exposure, steering away from USD and U.S. bonds. The broader
                takeaway? <span className="highlightedText">Globalisation is being replaced by segmentation, </span> and the market narrative has moved decisively toward
                <span className="highlightedText"> medium-term inflation pressure</span>
                and <span className="highlightedText">capital realignment.</span>
              </p>
              <p>Despite short-term rallies, underlying market participation is weak:</p>

              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    Just
                    <span className="highlightedText"> 12.1% of S&P 500 stocks </span>
                    are above their 5DMA
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">337 S&P stocks hit new lows </span> vs just 19 new highs last week
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    Russell 1000:
                    <span className="highlightedText"> 688 new lows vs 40 new highs </span>
                  </p>
                </li>
              </ul>
              <p>
                Even the Nasdaq 100—hovering near all-time highs—posted a <span className="highlightedText"> net-61 </span> in new highs vs lows. Breadth is worse than it looks. The rally has
                <span className="highlightedText"> narrowed, </span>
                and historically, this kind of deterioration precedes major risk-off moves.
              </p>
            </div>
            <div className="imageWrapperCont">
              <div className="relatedImg">
                <img
                  src={image6}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image6)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
              <div className="relatedImg">
                <img
                  src={image8}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image8)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Macro & Policy Watch: Bond Yields Won’t Blink</p>
              <p className="highlightedText">The Big Bill Passes, But So Do Big Worries</p>
              <p>
                Trump's tax bill passed the House, but not without serious dissent. The Senate will likely soften it, but it’s already filled with long-term fiscal risks. As Bessent admitted,{" "}
                <span className="highlightedText"> “We’re going for growth to fix the deficit.”</span> Translation? Print money, suppress yields, or{" "}
                <span className="highlightedText"> devalue the dollar by 40%</span> to shrink the debt-to-GDP ratio.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image2}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image2)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image5}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image5)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                This fiscal pivot comes just as long bonds throw a tantrum. The 20Y auction midweek was brutal, with yields hitting <span className="highlightedText"> 5.1%,</span> a level not seen
                since 2007.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image30}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image30)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image4}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image4)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>

              <p>And it’s not just the U.S. :</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Japanese yields are surging, </span>
                    threatening a capital repatriation wave
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Foreign inflows are drying up </span>just as the U.S. ramps up issuance
                  </p>
                </li>
              </ul>

              <p>
                The dollar, meanwhile, isn’t trading on rate differentials—it’s trading on <span className="highlightedText">capital flows </span>and
                <span className="highlightedText"> fiscal credibility. </span> Waller offered a hint: if tariffs stay capped at 10%, the Fed could ease. But if chaos drags into late summer, all bets
                are off.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image3}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image3)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image23}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image23)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>“5% long bond yields are the new line in the sand. The market is deciding, not the Fed.”</p>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Technical & Sentiment Setups: Rally Has No Legs</p>
              <p>Markets are near highs, but momentum is rotten. Short-term breadth has cratered, and institutional hedges are stacking up. That’s a classic bull trap setup.</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Only 18.8% of Nasdaq stocks are above 5DMA</span>
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">SPX P/E multiples under pressure from rising 5%+ yields</span>
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Bear ETF flows dwarf bullish flows in both size and quality</span>
                  </p>
                </li>
              </ul>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image21}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image21)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image20}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image20)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image31}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image31)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>Breadth isn’t just weak—it’s deteriorating faster than index watchers realise. This realises the same internal setup that led to the 2018 Q4 and 2022 mid-cycle rug pulls.</p>
              <div className="relatedImg">
                <img
                  src={image7}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image7)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
              <p>Gold and Bitcoin are soaking up safe-haven flows. BTC tagged a new ATH at $111K and chatter o,f $300K targets is growing.</p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image13}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image13)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image11}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image11)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <hr className="divisionLine" />
            </div>
          </div>
        </div>
        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Last Week in Review: Trump, Tariffs & Tech Divergence</p>
              <p className="highlightedText">Macro Recap:</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">UK CPI beat </span>with Core at 3.8%, while <span className="highlightedText">German PPI collapsed</span>—global disinflation lingers
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">U.S. PPI and existing home sales disappointed, </span>while durable goods suggested capex stabilisation
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Gold surged, BTC flew </span>and the dollar lost friends fast
                  </p>
                </li>
              </ul>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image17}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image17)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image19}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image19)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image15}
                    alt=""
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image15)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="contentDiv listOfRecap">
            <p className="highlightedText">Earnings Snapshot:</p>
            <ul className="pointersSection">
              <li className="themesPointer">
                <p>
                  <span className="highlightedText">Urban Outfitters +22.8% : </span>Comps, margins, and subs all beat
                </p>
              </li>
              <li className="themesPointer">
                <p>
                  <span className="highlightedText">Ross Stores -14% : </span>Withdrew guidance over tariff risk
                </p>
              </li>
              <li className="themesPointer">
                <p>
                  <span className="highlightedText">Deckers -16%, Target and Home Depot both weak</span>
                </p>
              </li>
              <li className="themesPointer">
                <p>
                  <span className="highlightedText">Snowflake +14%, Intuit +8% :</span> AI and cloud remain bright spots
                </p>
              </li>
            </ul>
            <div className="imageWrapperCont">
              <div className="relatedImg">
                <img
                  src={image18}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image18)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
              <div className="relatedImg">
                <img
                  src={image36}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image36)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
            </div>
            <p>The standout? Defensive positioning, not earnings growth, drove moves. Even strong beats were met with scepticism unless macro tailwinds aligned.</p>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Week Ahead: NVIDIA and the Inflation Domino</p>
              <p>This week could tip the balance. The calm in VIX, VVIX, and MOVE is deceptive. Events to watch:</p>
              <p className="highlightedText">Monday, May 26 (US Half Day)</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>Bank holiday</p>
                </li>
                <li className="themesPointer">
                  <p>Powell speaks (1940 UK)</p>
                </li>
                <li className="themesPointer">
                  <p>CHF employment, JPY Leading Indicators</p>
                </li>
                <li className="themesPointer">
                  <p>Earnings: JOYY Inc</p>
                </li>
              </ul>

              <p className="highlightedText">Tuesday, May 27</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>US Durable Goods, Wholesale Sales, HPI</p>
                </li>
                <li className="themesPointer">
                  <p>Earnings: PDD Holdings, Xiaomi ADR, AutoZone</p>
                </li>
                <li className="themesPointer">
                  <p>Fed speakers: Kashkari, Hauser, Nagel</p>
                </li>
              </ul>

              <p className="highlightedText">Wednesday, May 28</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">NVIDIA earnings after hours</span>—the week's main event
                  </p>
                </li>
                <li className="themesPointer">
                  <p>FR Consumer Spending, GDP, PPI</p>
                </li>
                <li className="themesPointer">
                  <p>CHF ZEW, US Richmond/Dallas PMIs</p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">OPEC Meeting</span>
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">FOMC Minutes (1900 UK)</span>
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Earnings: Salesforce, BAE, Macy’s, Synopsys, C3.ai</span>
                  </p>
                </li>
              </ul>

              <p className="highlightedText">Thursday, May 29</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>US GDP (2nd read), Initial Claims, Pending Home Sales</p>
                </li>
                <li className="themesPointer">
                  <p>Earnings: DELL, Best Buy, Zscaler, Lululemon, Gap, AEO</p>
                </li>
                <li className="themesPointer">
                  <p>Switzerland & Sweden closed for Ascension Day</p>
                </li>
              </ul>

              <p className="highlightedText">Friday, May 30</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    Big data day:<span className="highlightedText"> US PCE,</span> Chicago PMI, Goods Trade Balance, Michigan Inflation Expectations
                  </p>
                </li>
                <li className="themesPointer">
                  <p>GDP from Germany, Italy, and Canada</p>
                </li>
                <li className="themesPointer">
                  <p>Earnings: Costco, Shoe Carnival, Up Fintech</p>
                </li>
              </ul>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image33}
                    alt="nas100 wedge"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image33)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image23}
                    alt="ES gap on China"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image23)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Alpha Takeaway: Fade the Bounce, Watch the Internals</p>
              <p>The bounce into Memorial Day has little breadth, heavy hedging, and bond pressure behind it. Unless SPX breadth improves and yields settle, we’re staring down a likely retest.</p>
              <p>“Capital is voting with its feet—out of the dollar, into gold, commodities, and global equities.”</p>

              <p className="highlightedText">Watch for:</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>SPX breadth recovery—if it doesn’t come soon, a sharp leg down is in play</p>
                </li>
                <li className="themesPointer">
                  <p>NVIDIA’s impact—can it re-ignite sentiment or confirm tech fatigue?</p>
                </li>
                <li className="themesPointer">
                  <p>PCE and Michigan data—core to assessing the Fed’s next move</p>
                </li>
                <li className="themesPointer">
                  <p>30Y and 20Y auctions—bond vigilantes are back</p>
                </li>
                <li className="themesPointer">
                  <p>USD flows, if the dollar cracks further, ex-US equities and commodities may shine</p>
                </li>
              </ul>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image28}
                    alt="nas100 wedge"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image28)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image10}
                    alt="ES gap on China"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image10)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="button_wrapper">
          <button
            className="gradientButton_small "
            onClick={() => {
              handleRedirect("https://docs.google.com/document/d/1WVtx9Ps8bO8vaXXj3hrEgA2IBmYIvFewOi4ulEFlxx8/edit?tab=t.0");
            }}
          >
            Read In-Depth Market Outlook
          </button>
        </div>
      </div>
      {selectedImage && (
        <BlogImagePopper
          image={selectedImage}
          onClose={() => handleLargeImg(null)}
        />
      )}
    </div>
  );
};

export default Blog20;
